import React from "react";

export const FilterChevron = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="none">
        <g clip-path="url(#clip0_8771_2410)">
          <path
            d="M14.8093 0.772065L14.1907 0.153346C14.0442 0.00690865 13.8068 0.00690864 13.6603 0.153346L7.99999 5.80019L2.33968 0.153346C2.19324 0.00690813 1.95581 0.00690812 1.80934 0.153346L1.19062 0.772064C1.04418 0.918502 1.04418 1.15594 1.19062 1.30241L7.73481 7.8466C7.88124 7.99303 8.11868 7.99303 8.26515 7.8466L14.8093 1.30241C14.9558 1.15594 14.9558 0.918503 14.8093 0.772065Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_8771_2410">
            <rect width="8" height="16" fill="white" transform="translate(16) rotate(90)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
